import React, {useEffect, useState} from 'react';
import IndividualTiles from './FormComponents/IndividualTiles';
import HelpPanel  from './FormComponents/HelpPanel';
import NoSearchResults from './FormComponents/NoSearchResults';
import LocalTownsList from './Search/LocalTownsList';
import { formatSearchLocationText } from '../data/searchHelper';
import { ACCOUNTANT_ID, LEGAL_ADVISER_ID, API_KEYS } from '../__constants__';
import Button from './Inputs/Button';
import Select from './Inputs/Select';
import SelectOption from './Inputs/SelectOption';
import ProviderExplainerBanner from "./ProviderExplainerBanner";
import {getBanners, getProviderList, NUMBER_OF_BANNER_SLOTS} from "../utils/bannerUtils";
import {get, isEmpty, startCase} from "lodash";

export const resultsTitle = (resultsCount, { searchType, role, location, firstName, secondName }, remaining) => {
    if (searchType === 'location') {
        const count = resultsCount - remaining;

        return `Showing the top ${count} rated and reviewed ${role} near ${formatSearchLocationText(location)} (out of ${resultsCount})`;
    }

    if (searchType === 'name') {
        if (firstName && secondName) {
            return `Professionals matching ${firstName} ${secondName}`;
        }

        return firstName ? `Professionals matching ${firstName}` : `Professionals matching ${secondName}`;
    }
}

export default function SearchPageListings(props) {
    const [providerBannerList, setProviderBannerList] = useState([])
    const [banners, setBanners] = useState([])
    const [showProviderBanners, setShowProviderBanners] = useState(false)
    const { data, verticalId, searchType, firstName, secondName, servicesList } = props;
    const resultsCount = get(data, ['aggregate_data', 'count']);
    const remaining = get(data, ['aggregate_data', 'remaining']);

    const showMoreNumber = data.data ? resultsCount - data.data.length : resultsCount;
    const helpPanelAfter = 3

    useEffect(() => {
        setProviderBannerList(getProviderList())
        const query = new URLSearchParams(window.location.search);
        const banners = query.get('banners');
        setShowProviderBanners(((parseInt(banners) === 1) || parseInt(API_KEYS.SHOW_PROVIDER_BANNERS) === 1))
    }, []);

    useEffect(() => {
        setBanners(getBanners(servicesList, providerBannerList, verticalId))
    }, [providerBannerList, servicesList]);

    const renderTiles = (item, firstTile) => {
        const { verticalId, location, searchType } = props;
        const sortType = get(props, 'sortBy', null);
        const showBestMatch = firstTile && sortType === 'sigmoid';
        const searchLocation = location ? startCase(location.toLowerCase()) : '';
        return (
            <div key={`search-page-tile:${item.id}`} className='m-6 grow-0 max-w-full basis-full box-border'>
                <IndividualTiles
                    data={item}
                    showBestMatch={showBestMatch}
                    verticalId={verticalId}
                    searchLocation={searchLocation}
                    searchType={searchType}
                />
            </div>
        );
    }

    const sortByOptions = [
        { label: 'Best Match', value: 'sigmoid' },
        { label: 'Distance', value: 'distance' },
        { label: 'Review Count', value: 'review-count' }
    ]

    return (
        <div className="sm:mt-10 mt-2">
            {
                !isEmpty(data.data)
                ? <div className="w-[calc(100% + 16px)] -m-2 flex flex-wrap box-border p-2">
                    <div className="flex justify-between sm:m-3 sm:mt-2 grow-0 max-w-full basis-full box-border m-0 flex-col sm:flex-row sm:pl-2 sm:pr-2 mb-2">
                        <div>
                            <h1 className="font-semibold text-primary-blue sm:text-[1.25rem] leading-[32px] sm:m-0 mt-2 text-[1rem]">
                                { resultsTitle(resultsCount, props, remaining) }
                            </h1>
                        </div>
                        <div className="xs:flex items-center content-center mt-0 p-0 hidden">
                            <p className="text-[1.1rem] font-normal leading-6 font-['Nunito'] m-0 mr-2">
                                Sort by:
                            </p>

                            <div className="w-44">
                                <Select
                                    id="sort-by-options"
                                    defaultSelection={sortByOptions.find(opt => opt.value === props.sortBy)}
                                    onSelection={(selection) => props.handleSortByChange({ target: selection })}
                                    options={sortByOptions}
                                    renderOption={(option, isSelected) => (
                                        <SelectOption label={option.label} isSelected={isSelected} />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        [ACCOUNTANT_ID, LEGAL_ADVISER_ID].includes(verticalId) &&
                        <div className="md:pr-4 md:pb-5 md:pl-4 pt-0 pr-2 pb-8 pl-2 mb-2">
                            <LocalTownsList label="Covering:" vertical_id={verticalId}/>
                        </div>
                    }
                    {
                        data.data.map((item, index) => {
                            if (index === helpPanelAfter - 1) {
                                return (
                                    <>
                                        {renderTiles(item, index === 0)}
                                        <div
                                            className='grow-0 max-w-full basis-full m-0 box-border w-full flex flex-wrap my-4 xs:mx-6'>
                                            {(banners.length === 0 || !showProviderBanners) && <HelpPanel verticalId={verticalId}/>}
                                            {(banners.length > 0 && showProviderBanners) && <ProviderExplainerBanner {...banners[0]} />}
                                        </div>
                                    </>
                                );
                            } else if (index === helpPanelAfter + 1) {
                                return (
                                    <>
                                        {renderTiles(item, index === 0)}
                                        {(banners.length === NUMBER_OF_BANNER_SLOTS && showProviderBanners) &&
                                            <div className='grow-0 max-w-full basis-full m-0 box-border w-full flex flex-wrap mx-0 my-4 xs:mx-6'>
                                                <ProviderExplainerBanner {...banners[1]} />
                                            </div>
                                        }
                                    </>
                                )
                            } else {
                                return renderTiles(item, index === 0);
                            }
                        })
                    }
                        {
                            get(data, ['data'])
                                ? get(data, ['aggregate_data', 'count']) > get(data, ['data', 'length']) && (
                                <div className='flex justify-center grow-0 max-w-full basis-full m-0 box-border'>
                                    <Button
                                        text={`Show next ${showMoreNumber <= 5 ? showMoreNumber : 5} `}
                                        id="display_next_button"
                                        onClick={props.handleChange ? props.handleChange : () => {}}
                                    />
                            </div>
                        )
                        : ''
                    }
                </div>
                : ( searchType === 'name' && !(firstName || secondName) ? (
                        <p className='text-center pt-7 text-[1.1rem] leading-6 font-semibold m-0'>
                            Enter a name above and click search
                        </p>
                    ) : (
                        <NoSearchResults searchType={searchType} />
                    )
                    )
                }
        </div>
    );
}
